import request from '@/utils/request'

// 获取用户对挂号看诊医生待评价列表
export function reservedToBeCommentedList(data) {
  return request({
    url: '/api/comment/reservedToBeCommentedList/page',
    method: 'get',
    params: data,
  })
}

// 获取用户对挂号看诊医生待评价列表(合作就诊信息)
export function getInPatient(data) {
  return request({
    url: '/api/comment/getInPatient',
    method: 'get',
    params: data,
  })
}

// 获取用户对挂号看诊医生已评价列表
export function reservedCommentedList(data) {
  return request({
    url: '/api/comment/reservedCommentedList/page',
    method: 'get',
    params: data,
  })
}
